import React from "react";
import { ArrowRight, CheckCircle2, Clock3, LineChart, Sparkles } from "lucide-react";

const heroStats = [
  { value: "30+", label: "PTE modules" },
  { value: "AI", label: "Instant scoring" },
  { value: "24/7", label: "Practice access" },
];

const highlights = [
  "Full-length PTE mock tests",
  "Speaking and writing feedback",
  "Progress analytics",
];

export default function Product_section() {
  return (
    <section className="overflow-hidden bg-gray-50 sm:grid sm:grid-cols-2 sm:items-center">
      <div className="p-8 md:p-12 lg:px-16 lg:py-24">
        <div className="mx-auto max-w-xl">
          <div className="inline-flex items-center gap-2 rounded-full border border-fuchsia-100 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm">
            <Sparkles className="h-4 w-4 text-fuchsia-800" />
            AI-powered PTE preparation platform
          </div>

          <h1 className="mt-6 text-4xl font-black tracking-tight text-gray-950 sm:text-5xl lg:text-6xl">
            Prep smarter for PTE with instant AI feedback.
          </h1>

          <p className="mt-5 max-w-xl text-base leading-8 text-gray-600 sm:text-lg">
            PrepNexis helps you practise full PTE mock tests, improve weak areas,
            and understand your score with clear speaking, writing, reading, and
            listening insights.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="/signup"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-gradient-to-r from-gray-700 via-gray-900 to-black px-6 py-3 text-sm font-semibold text-white shadow-lg shadow-gray-900/15 transition hover:-translate-y-0.5 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
            >
              <span className="inline-flex h-5 w-5 items-center justify-center rounded-full bg-white/15">
                <Sparkles className="h-3.5 w-3.5" />
              </span>
              Get free trial
              <ArrowRight className="h-4 w-4" />
            </a>

            <a
              href="/pricing"
              className="inline-flex items-center justify-center rounded-md border border-gray-300 bg-white px-6 py-3 text-sm font-semibold text-gray-900 transition hover:border-gray-900 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:ring-offset-2"
            >
              View plans
            </a>
          </div>

          <div className="mt-8 grid max-w-xl grid-cols-1 gap-3 sm:grid-cols-3">
            {heroStats.map((item) => (
              <div
                key={item.label}
                className="rounded-lg border border-gray-200 bg-white/80 px-4 py-3 shadow-sm"
              >
                <p className="text-2xl font-black text-gray-950">{item.value}</p>
                <p className="text-sm text-gray-500">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative h-full min-h-[360px] sm:min-h-[520px] lg:min-h-[640px]">
          <div className="absolute left-5 top-8 hidden rounded-lg border border-gray-200 bg-white p-4 shadow-xl shadow-gray-900/10 lg:block">
            <div className="flex items-center gap-3">
              <div className="rounded-md bg-gray-900 p-2 text-white">
                <LineChart className="h-5 w-5" />
              </div>
              <div>
                <p className="text-sm font-semibold text-gray-950">
                  Score trend
                </p>
                <p className="text-xs text-gray-500">Updated after each mock</p>
              </div>
            </div>
          </div>

          <div className="h-full overflow-hidden bg-gray-50 sm:h-[calc(100%_-_2rem)] sm:self-end sm:rounded-ss-[30px] md:h-[calc(100%_-_4rem)] md:rounded-ss-[60px]">
            <img
              alt="PrepNexis PTE practice dashboard preview"
              src="/image/23.png"
              className="h-full w-full object-cover"
            />
          </div>

          <div className="absolute bottom-5 left-5 right-5 rounded-lg border border-white/70 bg-white/95 p-4 shadow-xl backdrop-blur">
            <div className="mb-3 flex items-center gap-2 text-sm font-semibold text-gray-950">
              <Clock3 className="h-4 w-4" />
              Today&apos;s practice focus
            </div>
            <div className="grid gap-2 sm:grid-cols-3">
              {highlights.map((item) => (
                <div key={item} className="flex items-center gap-2 text-sm text-gray-600">
                  <CheckCircle2 className="h-4 w-4 shrink-0 text-fuchsia-800" />
                  <span>{item}</span>
                </div>
              ))}
            </div>
          </div>
      </div>
    </section>
  );
}
